<div class="main_profile">
    <div class="title_block">
        <mat-icon class="icon" (click)="backBtnClick()" svgIcon="backArrow"></mat-icon>
        <h3 class="profile_title">My Profile</h3>
    </div>
    <div class="user_info" *ngIf="isLogin">
        <div class="user_image">
            <img [src]="image" alt="">
        </div>
        <div class="user_detail">
            <h3>{{name}}</h3>
            <p>{{mobile}}</p>
        </div>
    </div>
    <div class="profile_detail">
        <div class="detail_section" (click)="router.navigate(['orders'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="myOrders"></mat-icon>
                <p class="profileText">My Orders</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
        <div class="detail_section" (click)="router.navigate(['wishlist'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="heart-empty"></mat-icon>
                <p class="profileText">My Wishlist</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
        <div class="detail_section" (click)="router.navigate(['compare'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="mobile-compare"></mat-icon>
                <p class="profileText">Compare Items</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
        <div class="detail_section" (click)="router.navigate(['appointments'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="appointement"></mat-icon>
                <p class="profileText">Appointements</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
        <div class="detail_section" (click)="router.navigate(['box'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="myCart"></mat-icon>
                <p class="profileText">My Cart</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
    </div>
    <div class="profile_detail">
        <div class="detail_section" (click)="router.navigate(['profile'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="myProfile"></mat-icon>
                <p class="profileText">Profile</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
        <div class="detail_section" (click)="router.navigate(['address'])">
            <div class="textAndIcon">
                <mat-icon class="icon" svgIcon="myAddress"></mat-icon>
                <p class="profileText">Address</p>
            </div>
            <mat-icon class="icon-size-18" svgIcon="frontArrow"></mat-icon>
        </div>
    </div>
    <div class="info">
        <div class="info_detail" (click)="router.navigate(['customJewellery'])">
            <p class="infoText">Custom jewellery</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['customer'])">
            <p class="infoText">Customer Review</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['faq'])">
            <p class="infoText">FAQ's</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['termsandconditions'])">
            <p class="infoText">Terms & Condition</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['privacypolicy'])">
            <p class="infoText">Privacy Policy</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['randrypolicy'])">
            <p class="infoText">Return & Refund Policy</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['aboutus'])">
            <p class="infoText">About Us</p>
        </div>
        <div class="info_detail" (click)="router.navigate(['help'])">
            <p class="infoText">Contact Us</p>
        </div>
    </div>
    <div class="logOutSection" *ngIf="isLogin" (click)="doLogout()">
        <div class="logOutText">
            logOut
        </div>
    </div>
    <div class="logOutSection" *ngIf="!isLogin" (click)="router.navigate(['/login'])">
        <div class="logOutText">
            SignUp / SignIn
        </div>
    </div>
</div>